import { useEffect } from "react";
import AOS from "aos";
import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";
import ContactFloat from "@/components/ContactFloat";
import IndustrySolutionSections from "@/components/IndustrySolutionSections";
import KnowledgeBaseMindMap from "@/components/KnowledgeBaseMindMap";

export default function PetFeederSolutions() {
  const { t } = useTranslation();

  useEffect(() => {
    AOS.init({
      offset: 100,
      easing: "ease-out-back",
      duration: 1000,
      delay: 100,
    });
  }, []);

  return (
    <>
      <Helmet>
        <title>{t("petFeeder.title")}</title>
        <meta name="keywords" content={t("petFeeder.keywords")} />
        <meta name="description" content={t("petFeeder.description")} />
      </Helmet>
      <ContactFloat />

      <section
        className="w-full bg-[#2d3a2e]"
        data-aos="fade-right"
        data-aos-offset="100"
        data-aos-duration="500"
      >
        <div className="relative isolate h-[400px] w-full overflow-hidden">
          <img
            src="/solutions/pet-feeder-banner.jpeg"
            alt=""
            className="absolute inset-0 h-full w-full object-cover object-[50%_20%]"
          />
          <div className="absolute inset-0 bg-linear-to-r from-[#1a261c]/92 via-[#1a261c]/72 to-transparent" />
          <div className="relative z-10 grid h-full w-1200 place-items-center px-4 text-center">
            <div>
              <h2
                className="text-[30px] leading-snug font-bold text-white"
                data-aos="fade-right"
                data-aos-offset="100"
                data-aos-duration="500"
              >
                {t("petFeeder.banner.title")}
              </h2>
              <span
                className="mx-auto mt-3 block h-[4px] w-[50px] bg-white"
                data-aos="zoom-in"
                data-aos-delay="300"
              />
              <p
                className="mt-5 text-base text-white/90 md:text-lg"
                data-aos="fade-left"
                data-aos-offset="100"
                data-aos-duration="500"
              >
                {t("petFeeder.banner.subtitle")}
              </p>
            </div>
          </div>
        </div>
      </section>

      <KnowledgeBaseMindMap
        rootLabel={t("petFeeder.knowledgeBase.rootLabel")}
        rootColor="#16a34a"
        treeTranslationKey="petFeeder.knowledgeBase.tree"
        i18nPrefix="petFeeder.knowledgeBase"
      />

      <IndustrySolutionSections
        i18nPrefix="petFeeder"
        images={{
          painPoints: "/solutions/pet-feeder-pain.jpeg",
          solutions: "/solutions/pet-feeder-solutions.jpeg",
          cta: "/solutions/pet-feeder-cta.jpeg",
        }}
        imagesPos={{
          painPoints: "50% 28%",
          solutions: "50% 30%",
          cta: "50% 10%",
        }}
      />
    </>
  );
}
